import { render, staticRenderFns } from "./TheMyOrdersTableDetailsRecipient.vue?vue&type=template&id=64055f8f&scoped=true"
import script from "./TheMyOrdersTableDetailsRecipient.vue?vue&type=script&lang=js"
export * from "./TheMyOrdersTableDetailsRecipient.vue?vue&type=script&lang=js"
import style0 from "./TheMyOrdersTableDetailsRecipient.vue?vue&type=style&index=0&id=64055f8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64055f8f",
  null
  
)

export default component.exports